// import qs from 'qs'
import { fetch } from '@/api/fetch'

// let path: string = process.env.VUE_APP_ProductionUrBendi!, //开发地址
//     tokenUrl: string = process.env.VUE_APP_TokenUrl! //token地址

//开发环境
// if (process.env.NODE_ENV === 'development') {
//     //更改vue.config.js地址
//     path = 'https://jd.ucuansime.com'
//     tokenUrl = '/token'

//     // path = '/official'
//     // tokenUrl = '/officialtoken'
// }

const apiUrl = {
    path: 'https://jd.ucuansime.com'
}

// export { apiUrl }

// username:贴息嚯嚯1
// password:a123456
// scope:fdAppWeb  登录类型
// client_id:fdAppWeb
// client_secret:fdAppWeb
// grant_type:password
/**
 * 通过账号密码获取access_token
 * @param params
 */
// export function loginGetToken(params: any) {
//     return fetch({
//         url: `${apiUrl.token}/oauth/token`,
//         headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
//         method: 'post',
//         data: qs.stringify(params)
//     })
// }

//解析信息
// export function tokenConversion(data: any) {
//     // /uaa/token/explain?explain_access_token=
//     return fetch({
//         url: `${apiUrl.token}/token/explain`,
//         params: {
//             explain_access_token: sessionStorage.getItem('access_token')
//         }
//     })
// }

//解析信息
// export function getAgent(data: any) {
//     // /uaa/token/explain?explain_access_token=
//     return fetch({
//         url: `${apiUrl.path}/dl/queryAgent`,
//         headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
//         method: 'post',
//         data: qs.stringify(data)
//     })
// }


// 验证码
// export function getNewsNumbeSms(data: any) {
//     return fetch({
//         url: `/prod-api/fd/cloud/sendSms`,
//         method: 'post',
//         data: JSON.stringify(data)
//     })
// }

// // 商务合作
// export function getNewsSumblit(data: any) {
//     return fetch({
//         url: `/prod-api/fd/cloud/businessCooperation`,
//         method: 'post',
//         data: JSON.stringify(data)
//     })
// }

// 表单
export function createMessage(data: any) {
    return fetch({
        url: `${apiUrl.path}/api/system/message?message=${data.message}`,
        method: 'post',
        data: JSON.stringify(data)
    })
}